(function () {
  const container = document.getElementById('reels-section');
  const grid = document.getElementById('reels-grid');
  const loading = document.getElementById('reels-loading');

  if (!container) return;

  const WORKER_URL = 'https://reels-proxy.dev-avaniglobal.workers.dev';
  const shop = container.dataset.shop;
  const columns = container.dataset.columns || 4;
  const gap = container.dataset.gap || 12;
  const autoplay = container.dataset.autoplay === 'true';

  container.style.setProperty('--reels-columns', columns);
  container.style.setProperty('--reels-gap', gap + 'px');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadReels();
          observer.disconnect();
        }
      });
    },
    { threshold: 0.1 }
  );

  observer.observe(container);

  async function loadReels() {
    try {
      // Step 1 — get selected IDs
      const selRes = await fetch(WORKER_URL + '?action=get_selected&shop=' + shop);
      const selData = await selRes.json();
      const ids = selData.ids || [];

      if (!ids.length) {
        loading.style.display = 'none';
        return;
      }

      // Step 2 — fetch selected reels
      const res = await fetch(
        WORKER_URL + '?action=public&shop=' + shop + '&ids=' + ids.join(',')
      );
      const data = await res.json();

      if (data.reels && data.reels.length) {
        renderReels(data.reels);
      } else {
        loading.style.display = 'none';
      }
    } catch (err) {
      loading.style.display = 'none';
    }
  }

  function renderReels(reels) {
    loading.style.display = 'none';

    reels.forEach((reel) => {
      const card = document.createElement('div');
      card.className = 'reel-card';

      const isVideo = reel.media_type === 'VIDEO';

      if (isVideo) {
        card.innerHTML = `
          <video
            src="${reel.media_url}"
            poster="${reel.thumbnail_url || ''}"
            muted playsinline loop preload="none"
            class="reel-media"
          ></video>
          <div class="reel-play-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
              <polygon points="5,3 19,12 5,21"/>
            </svg>
          </div>`;

        if (autoplay) {
          const video = card.querySelector('video');
          const icon = card.querySelector('.reel-play-icon');
          card.addEventListener('mouseenter', () => { video.play(); icon.style.opacity = '0'; });
          card.addEventListener('mouseleave', () => { video.pause(); video.currentTime = 0; icon.style.opacity = '1'; });
        }
      } else {
        card.innerHTML = `
          <img
            src="${reel.media_url}"
            alt="${reel.caption ? reel.caption.substring(0, 60) : 'Instagram post'}"
            loading="lazy"
            class="reel-media"
          />`;
      }

      grid.appendChild(card);
    });
  }
})();